import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'LauncherButton' })({
    button: {
        color: '#fff',
        borderRadius: 12,
        padding: '16px 32px',
        textTransform: 'none',
        background: 'linear-gradient(249deg, #FF8B61 7.18%, #D92E7F 172.88%)',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        flex: '1 1 auto'
    }
});
